module.exports = __webpack_public_path__ + "static/media/google-logo.87bb3083.png";